import { ActivatedRoute } from '@angular/router';

export const getLastActivatedRouteInChain = (activatedRoute: ActivatedRoute): ActivatedRoute => {
  let lastRoute = activatedRoute;
  while (lastRoute.firstChild) {
    lastRoute = lastRoute.firstChild;
  }
  return lastRoute;
};
